import '@fortawesome/fontawesome-free/css/all.css';
import router from 'views/components/crm/router.js';
import store from 'views/components/crm/store/index.js';
import IdleVue from 'idle-vue-3';
import axiosClient from 'views/components/crm/api/axiosClient.js';
import { localStorageService } from 'views/components/crm/api/localStorageService';

if (typeof window !== 'undefined' && window.history && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

Vue.prototype.base_url = base_url;
Vue.prototype.api_url = api_url;

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 60000,
});

new Vue({
  router,
  store,
  el: '#app',
  components: {
    App: () => import('views/components/crm/App.vue'),
  },
  async onActive() {
    try {
      // No verificar sesión si estamos en la ruta de login
      const currentRoute = this.$route || (this.$router && this.$router.currentRoute);
      if (
        currentRoute &&
        (currentRoute.path === '/login' || currentRoute.name === 'login')
      ) {
        return;
      }
      const { data } = await axiosClient.get('account/sesion_activa', { timeout: 30000 });
      if (data && data.activa === false) {
        localStorageService.destruirSesion();
        this.$router.replace({ path: '/login' });
      }
    } catch (e) {}
  },
});
